import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 1.33a.666.666 0 0 0-.666.667v.424A6.02 6.02 0 0 1 8 4.663H4a2 2 0 0 0-2 2v1.334a2 2 0 0 0 2 2h.323L2.72 13.734a.666.666 0 0 0 .612.93H6a.67.67 0 0 0 .613-.405l1.815-4.237a6.02 6.02 0 0 1 4.239 2.217v.424a.667.667 0 1 0 1.333 0V1.997a.667.667 0 0 0-.667-.667M4 8.663a.667.667 0 0 1-.667-.666V6.663A.667.667 0 0 1 4 5.997h.667v2.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })